<template>
  <div class="help">
    <div v-html="html"></div>
  </div>
</template>

<script>
import Vue from 'vue';
import { List, PullRefresh } from 'vant';
import { resource } from './resource';

Vue.use(List);
Vue.use(PullRefresh);

export default {
  name: 'Help',
  data() {
    return {
      resource,
      // 对应的顺序 Help Center
      id: +this.$route.params.id,
    };
  },
  computed: {
    html: function() {
      const { resource, id } = this;
      return resource[id].html;
    },
  },
  metaInfo() {
    const { resource, id } = this;
    const { title } = resource[id];
    return { title };
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.help {
  max-width: 720px;
  margin: 0px auto;
  padding: 16px;
}
</style>
